import styled from 'styled-components';

export const ViewContainerStyled = styled.div`
    height: 100% !important;

`;